import { Dropdown, Space } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { PERFORM_TOGGLE_SUBMISSIONS_PAUSED_MUTATION } from '@applicant-flow/graphql';
import { BaseButton, Icon } from '@common/components';
import { useMutation } from '@common/hooks';
import { createMessage } from 'works/legacy/lib/message-helper';

export function SubmissionsPausedDropdown({
  staffingRequestId,
  submissionsPaused,
  canUpdate,
}) {
  const [submitting, setSubmitting] = useState(false);

  const onClickWithConfirmation = () => {
    if (submitting) return;

    setSubmitting(true);
    performAction({
      variables: {
        staffingRequestId: staffingRequestId,
        input: {
          action: 'accept',
        },
      },
    });
  };

  const [performAction] = useMutation(
    PERFORM_TOGGLE_SUBMISSIONS_PAUSED_MUTATION,
    {
      onError: () => {
        createMessage('error', 'Failed to update staffing request');
      },
      onCompleted: () => {
        setSubmitting(false);
      },
    }
  );

  const resumeSubmissionsMenuItem = [
    {
      label: 'Resume submissions',
      key: 'resume_submissions',
    },
  ];

  const pauseSubmissionsMenuItem = [
    {
      label: 'Pause new submissions',
      key: 'pause_submissions',
    },
  ];

  const currentStatusBody = submissionsPaused ? (
    <Space align="baseline">
      <Icon icon="doNotEnter" color="rubyRed" size="sm" />
      Not accepting submissions
    </Space>
  ) : (
    <Space align="baseline">
      <Icon icon="circle" color="grassMid" size="sm" />
      Accepting Submissions
    </Space>
  );

  if (!canUpdate) return <>{currentStatusBody}</>;

  return (
    <Dropdown
      menu={{
        onClick: onClickWithConfirmation,
        items: submissionsPaused
          ? resumeSubmissionsMenuItem
          : pauseSubmissionsMenuItem,
      }}
      disabled={submitting}
    >
      <BaseButton>
        {currentStatusBody} <Icon icon="chevronDown" kind="light" size="sm" />
      </BaseButton>
    </Dropdown>
  );
}

SubmissionsPausedDropdown.propTypes = {
  staffingRequestId: PropTypes.string,
  submissionsPaused: PropTypes.bool.isRequired,
  canUpdate: PropTypes.bool.isRequired,
};
